module.exports = __webpack_public_path__ + "1b06be3691ae0c9234f027a29649841a.svg";